import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Address } from 'src/app/models/address.model';
import { FocusSettings } from 'src/app/models/app-settings.model';
import { CompanyInfo } from 'src/app/models/company-info.model';
import { SoilInfo } from 'src/app/models/soil-info.model';
import { CustomerSettingsResponse } from 'src/app/services/request-models/customer-settings.model';
import { ElasticLocation } from 'src/app/services/request-models/elastic-api.model';

export const SettingsActions = createActionGroup({
  source: 'Settings',
  events: {
    'Set User Address': props<{ address: Address }>(),
    'Set Company Info': props<{ companyInfo: CompanyInfo }>(),
    'Set Soil Info': props<{ soilInfo: SoilInfo }>(),
    'Set App Focus Settings': props<{ focusSettings: FocusSettings }>(),
    'Finalize onboarding': emptyProps(),
    'Finalize onboarding success': props<{
      response: CustomerSettingsResponse;
    }>(),
    'Finalize onboarding failure': props<{ message: string }>(),
    'Set Settings': props<{ response: CustomerSettingsResponse }>(),
    'Update onboarding settings': emptyProps(),
    'Load User Locations': emptyProps(),
    'Load User Locations success': props<{ response: ElasticLocation[] }>(),
    'Load User Locations failure': props<{ message: string }>(),
    'Search User Locations': props<{ query?: string }>(),
    'Search User Locations success': props<{ response: ElasticLocation[] }>(),
    'Search User Locations failure': props<{ message: string }>(),
    'Set Location': props<{ location: ElasticLocation }>(),
  },
});

export default SettingsActions;
